import axios from 'axios'
import store from './store/index'

axios.interceptors.request.use(config => {
    const token = store.state.oidcStore.access_token;
    if (token) config.headers["Authorization"] = "Bearer " + token;
    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(res => {
    if (!res.data.success) return Promise.resolve(res);
    return res;
}, error => {
    return Promise.reject(error);
});
export default axios;


// WEBPACK FOOTER //
// ./src/axiosConfig.js